import DogsStore from './DogsStore'

export default {
  dogsStore: new DogsStore()
}
